import { usePayrollPrices } from '../payrollPrice.hooks'

export const SubscriptionIncrease = () => {
  const { seat } = usePayrollPrices()

  if (!seat) {
    return <>Your Heard subscription will increase.</>
  }

  return (
    <>
      Your Heard subscription will increase by <b>{seat}/month.</b>
    </>
  )
}
